import React from 'react'
import Link from 'gatsby-link'
import GatsbyConfig from '../../../gatsby-config.js'

const { siteMetadata: config } = GatsbyConfig

export default class SoldOutBanner extends React.Component {
  render() {
    const { trips } = config
    const { trip, showSoldOut, to } = this.props
    const tripData = trips[trip]
    const toTripData = trips[to]

    return (
      <Link className="banner sold-out-banner" to={`/${toTripData.slug}`}>
        <span className="wrap">
          <span className="message">
            SOLD OUT
            <span className="custom">
              {tripData.soldOutReferralText}
              &nbsp;<i className="fa fa-external-link" />
            </span>
          </span>
        </span>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/sold-out-banner.js